import { ImageField, LinkField, StringField, THeadingTag, VideoSitecoreField, TLinkField } from '../../../types/types';
import {
  TSpecialOffersFields,
  TSpecialOffersParams,
  TSpecialOffersProps,
  TSpecialOffersSlideFields,
  TSpecialOffersSlideProps,
} from '../types/cardCarousel.types';
import { BACKGROUND_COLOR_MAP } from '../../../constants/background-color.constants';
import { getFollowingHTag } from '../../../utils/seo.utils';

export class SpecialOffersSlideModel {
  private readonly fields: null | TSpecialOffersSlideFields;
  private readonly _id?: string;

  constructor(props: TSpecialOffersSlideProps) {
    this.fields = props?.fields || null;
    this._id = props.id ?? props.dataSource;
  }

  get id(): string {
    return this._id as string;
  }

  get type(): StringField | null {
    return this.fields?.cardType?.fields?.Key || null;
  }

  get title(): StringField | null {
    return this.fields?.title || null;
  }

  get subtitle(): StringField | null {
    return this.fields?.subtitle || null;
  }

  get label(): StringField | null {
    return this.fields?.label || null;
  }

  get badgeLink(): LinkField | null {
    return this.fields?.badgeLink || null;
  }

  get image(): ImageField | undefined {
    return this.fields?.image;
  }

  get mobileImage(): ImageField | undefined {
    return this.fields?.mobileImage;
  }

  get buttonPrimary(): LinkField | undefined {
    return this.fields?.buttonPrimary;
  }

  get buttonSecondary(): LinkField | undefined {
    return this.fields?.buttonSecondary;
  }

  get isWideCard(): boolean {
    return this.type?.value === 'offerCardWide';
  }

  get useVideo(): boolean {
    return this.fields?.useVideo?.value || false;
  }

  get video(): VideoSitecoreField | undefined {
    return this.fields?.video;
  }
}

export class SpecialOffersModel {
  private readonly fields: null | TSpecialOffersFields;
  private readonly params: null | TSpecialOffersParams;

  constructor(props: TSpecialOffersProps) {
    this.fields = props?.fields || null;
    this.params = props?.params || null;
  }

  get backgroundColor(): string | undefined {
    return BACKGROUND_COLOR_MAP.get(this.params?.backgroundColor || '');
  }

  get eyebrow(): StringField | undefined {
    return this.fields?.eyebrow;
  }

  get link(): TLinkField | undefined {
    return this.fields?.link;
  }

  get title(): StringField | undefined {
    return this.fields?.title;
  }

  get subtitle(): StringField | undefined {
    return this.fields?.subtitle;
  }

  get items(): SpecialOffersSlideModel[] {
    if (this.fields && this.fields?.items) {
      return this.fields?.items.map((Card: TSpecialOffersSlideProps) => {
        return new SpecialOffersSlideModel(Card);
      });
    } else {
      return [];
    }
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h2';
  }

  get cardHeadingTitleTag(): THeadingTag {
    return getFollowingHTag(this.headingTag);
  }
}
